import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router';
import { styled } from '@mui/material/styles';
import DashboardSidebar from './DashboardSidebar';
import ChatWidget from '../chat/ChatWidget';
import { Header } from '../Header';
import { UserProfileProvider } from 'src/contexts/UserProfileContext';
import { SubscriptionPermissionsProvider } from 'src/mindtime/contexts/SubscriptionPermissionsContext';
import useHasPermissions from 'src/hooks/useHasPermission';
import { CLIENT_CHATS } from 'src/constants/constants';

interface DashboardLayoutProps {
  children?: ReactNode;
}

const DashboardLayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%',
  flexDirection: 'column'
}));

const DashboardLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  minHeight: 0,
  overflow: 'hidden',
});

const DashboardLayoutContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  WebkitOverflowScrolling: 'touch',
});

const DashboardLayout: FC<DashboardLayoutProps> = () => {
  const checkPermissions = useHasPermissions();
  const canAccessChat = checkPermissions([CLIENT_CHATS]);

  return (
    <UserProfileProvider>
      <SubscriptionPermissionsProvider>
        <DashboardLayoutRoot>
        {/* Global header above sidebar and content */}
        <Header />

        {/* Row: sidebar + content */}
        <div
          style={{
            display: 'flex',
            flex: '1 1 auto',
            minHeight: 0, // allow inner area to control scroll
            overflow: 'hidden'
          }}
        >
          <DashboardSidebar />

          <DashboardLayoutContainer>
            <DashboardLayoutContent>
              <div
                style={{
                  backgroundColor: '#F7FAFC',
                  flex: '1 1 auto',
                  minHeight: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'auto',
                }}
              >
                <Outlet />
              </div>
            </DashboardLayoutContent>
          </DashboardLayoutContainer>
        </div>

        {canAccessChat && <ChatWidget />}
      </DashboardLayoutRoot>
      </SubscriptionPermissionsProvider>
    </UserProfileProvider>
  )
};
export default DashboardLayout;
